"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _BottomIconButtons = require("./BottomIconButtons");
Object.keys(_BottomIconButtons).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _BottomIconButtons[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _BottomIconButtons[key];
    }
  });
});
var _TopIconButtons = require("./TopIconButtons");
Object.keys(_TopIconButtons).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _TopIconButtons[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _TopIconButtons[key];
    }
  });
});
var _NotifyMe = require("./NotifyMe");
Object.keys(_NotifyMe).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _NotifyMe[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _NotifyMe[key];
    }
  });
});
//# sourceMappingURL=index.js.map